import { render } from "./StatusIcon.vue?vue&type=template&id=175b56e1&scoped=true"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"

import "./StatusIcon.vue?vue&type=style&index=0&id=175b56e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175b56e1"]])

export default __exports__